import { animate, stagger } from '../../vendor/anime.esm.js';
import { DURATION, EASE, STAGGER, resolveDuration, resolveStagger } from '../motion-tokens.js';

/**
 * Coreografía de entrada del bloque `reserva-live`.
 *
 * POR QUÉ EXISTE (gotcha #18): una variante SIN entrada en variant-animations.js cae al
 * fallback genérico del orquestador, que es frágil — writes solapados de anime.js pueden
 * CONGELAR un tween a mitad y dejar texto semi-invisible PARA SIEMPRE en el sitio publicado
 * (el bug real del `<p>` de los bloques `content`). Un bloque que promete reservas no puede
 * permitirse eso, así que trae la suya.
 *
 * Registrada con clave SIN variante ('reserva-live'): v1 y v2 comparten coreografía (el
 * lookup cae de 'reserva-live-v1' → 'reserva-live'). DRY.
 *
 * Solo fade + desplazamiento (sin split-text ni clipPath): seguro en motion 'reduced' y sin
 * depender del scroll-timeline CSS. Se FUERZA el estado inicial antes de que el orquestador
 * añada `.anime-init` y revele la sección → no hay flash del widget entero antes del stagger.
 *
 * OJO: se anima el CHROME del widget (cabecera, pasos, tarjeta), NO los chips de personas ni
 * las celdas del calendario: los pinta el runtime en cuanto hidrata, y animarlos por separado
 * competiría con ese repintado (y con cada cambio de mes) escribiendo los mismos targets.
 */
export const reservaLiveAnim = (el) => {
    const head = el.querySelector('.rl-head');
    const pasos = el.querySelectorAll('.rl-step');
    const tarjeta = el.querySelector('.rl-widget');
    if (!tarjeta) return null;

    if (head) { head.style.opacity = '0'; head.style.transform = 'translateY(22px)'; }
    tarjeta.style.opacity = '0';
    tarjeta.style.transform = 'translateY(28px)';
    tarjeta.style.filter = 'blur(4px)';
    pasos.forEach((p) => { p.style.opacity = '0'; });

    if (head) {
        animate(head, {
            opacity: [0, 1],
            translateY: [22, 0],
            duration: resolveDuration(DURATION.normal),
            ease: EASE.refined,
        });
    }

    // Primario: la tarjeta del asistente (es el objeto de la sección).
    animate(tarjeta, {
        opacity: [0, 1],
        translateY: [28, 0],
        filter: ['blur(4px)', 'blur(0px)'],
        delay: head ? resolveDuration(DURATION.normal) * 0.35 : 0,
        duration: resolveDuration(DURATION.slow),
        ease: EASE.snappy,
    });

    // Secundario: los tres pasos se encienden en cascada, contando la historia del flujo.
    if (pasos.length) {
        animate(pasos, {
            opacity: [0, 1],
            translateY: [10, 0],
            delay: stagger(resolveStagger(STAGGER.normal), { start: resolveDuration(DURATION.normal) * 0.6 }),
            duration: resolveDuration(DURATION.fast),
            ease: EASE.snappy,
        });
    }

    return null;
};
